'use strict';

export enum PopoverShowOn {
  Click = 'Click',
  Hover = 'Hover',
}
